<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/resources',
          title: 'Resources'
        },
        {
          href: canonicalPaths.relative,
          title: 'Video'
        }
      ]"
      :value="heroSection"
    />

    <VideoSection
      :video="video"
      :value="{}"
      class="mb-16 px-md-16 hero-section hero-below-offset"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection :value="videoPage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePageContext } from '#root/renderer/usePageContext'

const props = defineProps({
  video: {
    required: true,
    type: Object
  },
  videoPage: {
    required: true,
    type: Object
  }
})

const { canonicalPaths } = usePageContext()
const heroSection = computed(() => {
  const section = Object.assign({}, props.videoPage.hero_section)
  section.title = props.video.title
  return section
})
</script>
